/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Output_Move_DownInputs */

const en_audio_embed_export_output_move_down = /** @type {(inputs: Audio_Embed_Export_Output_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move down`)
};

const fr_audio_embed_export_output_move_down = /** @type {(inputs: Audio_Embed_Export_Output_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descendre`)
};

const de_audio_embed_export_output_move_down = /** @type {(inputs: Audio_Embed_Export_Output_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach unten schieben`)
};

const it_audio_embed_export_output_move_down = /** @type {(inputs: Audio_Embed_Export_Output_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scendendo`)
};

const ru_audio_embed_export_output_move_down = /** @type {(inputs: Audio_Embed_Export_Output_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спуститесь вниз`)
};

const es_audio_embed_export_output_move_down = /** @type {(inputs: Audio_Embed_Export_Output_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baja`)
};

const zh_cn2_audio_embed_export_output_move_down = /** @type {(inputs: Audio_Embed_Export_Output_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向下`)
};

const ja_audio_embed_export_output_move_down = /** @type {(inputs: Audio_Embed_Export_Output_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下へ移動`)
};

const hi_audio_embed_export_output_move_down = /** @type {(inputs: Audio_Embed_Export_Output_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नीचे की ओर`)
};

const pt_pt2_audio_embed_export_output_move_down = /** @type {(inputs: Audio_Embed_Export_Output_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desça`)
};

/**
* | output |
* | --- |
* | "Move down" |
*
* @param {Audio_Embed_Export_Output_Move_DownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_output_move_down = /** @type {((inputs?: Audio_Embed_Export_Output_Move_DownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Output_Move_DownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_output_move_down(inputs)
	if (locale === "de") return de_audio_embed_export_output_move_down(inputs)
	if (locale === "it") return it_audio_embed_export_output_move_down(inputs)
	if (locale === "ru") return ru_audio_embed_export_output_move_down(inputs)
	if (locale === "es") return es_audio_embed_export_output_move_down(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_output_move_down(inputs)
	if (locale === "ja") return ja_audio_embed_export_output_move_down(inputs)
	if (locale === "hi") return hi_audio_embed_export_output_move_down(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_output_move_down(inputs)
	return en_audio_embed_export_output_move_down(inputs)
});